import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';

import { GridLayout } from 'components/form/layout';
import Dropdown from 'components/Dropdown';
import { TextField } from 'components/form/field';
import sortSettings from 'common/utils/sortSettings';
import { DELETE } from 'utils/httpMethods';

const ManagementActDropdown = ({ deleted, name, product }) => {
    const deleteSetting = useCallback(async (e) => {
        e.preventDefault();
        if (window.confirm('Supprimer le contrat ?')) {
            await DELETE(`/api/settings/simulation.managementAct.${product}`);
            window.location.reload(true);
        }
    }, []);

    return (
        <Dropdown title={`${deleted ? '(supprimé) ' : ''}${name}`} key={product}>
            <GridLayout className="double condensed full-width">
                <TextField
                    name={`simulation.managementAct.${product}.name`}
                    title="Nom"
                />
                <TextField
                    name={`simulation.managementAct.${product}.referrerCode`}
                    title="Code apporteur"
                />
            </GridLayout>
            <hr />
            <button className="theseis-btn" onClick={deleteSetting}>Supprimer le code</button>
        </Dropdown>

    );
};

ManagementActDropdown.propTypes = {
    deleted: PropTypes.bool,
    name: PropTypes.string.isRequired,
    product: PropTypes.string.isRequired,
};

const ManagementAct = ({ settings }) => (
    <Fragment>
        {sortSettings(settings).map(([product, { deleted, name }]) => (
            <ManagementActDropdown
                key={product}
                deleted={deleted}
                name={name}
                product={product}
            />
        ))}
    </Fragment>
);

ManagementAct.propTypes = {
    settings: PropTypes.shape({}).isRequired,
};

export default ManagementAct;
